import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";
import InfoPage from "../info/InfoPage";
import PageLoading from "../shared/PageLoading";

interface IProps extends RouteComponentProps {
	loggedIn: boolean | undefined;
	loading: React.ReactElement;
}

const LazyHome = lazy(() => import(/* webpackChunkName: "Home" */ "../home/Home"));

const HomePage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path, loading } = props;

	if (loggedIn === undefined) {
		return loading;
	}

	if (!loggedIn) {
		return <InfoPage />;
	}

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyHome loading={loading} />
	</ErrorBoundary>;
};

export default HomePage;